// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"0a175948","612":"e4662324","731":"392c9535","840":"a409a2c8","926":"b2b5dc25"}[chunkId] + ".chunk.css";
};